import * as React from "react";
import { Logger } from "bernie-logger";
import { logger } from "bernie-core";
import { FAILED_REGION_RENDER } from "src/config/systemEvents";

interface ErrorBoundaryProps {
  logger?: Logger;
}

@logger("ErrorBoundary")
export class ErrorBoundary extends React.Component<ErrorBoundaryProps, {}> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const moduleName = this.props.children && this.props.children["key"];

    // eslint-disable-next-line no-console
    console.log("Error in a module: ", moduleName, errorInfo, error);
    if (this.props.logger) {
      this.props.logger.logEvent(FAILED_REGION_RENDER, moduleName, errorInfo, error);
    }
  }

  public render() {
    return this.props.children;
  }
}
